import React from 'react';

function SpeakersWidget() {
  const speakers = [
    {
      name: 'David Sinclair',
      image: '/david-sinclair-headshot-2024.webp',
      link: '#david-sinclair'
    },
    {
      name: 'Matthew Walker',
      image: '/assets/matthew-walker-speaker.webp',
      link: '#matthew-walker'
    },
    {
      name: 'Dr. Daniel Amen',
      image: '/assets/amen-speaker.webp',
      link: '#dr-amen'
    },
    {
      name: 'Diana Palotas',
      image: '/Diana-Palotas-card.webp',
      link: '#diana-palotas'
    }
  ];

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="speakers-sidebar-global">
        {speakers.map((speaker, index) => (
          <div key={index} className="speaker-sidebar-item">
            <a href={speaker.link} className="speaker-sidebar-circle">
              <img 
                src={speaker.image} 
                alt={speaker.name} 
                loading="lazy"
              />
            </a>
            <span className="speaker-sidebar-name">{speaker.name}</span>
          </div>
        ))}
      </div>
    </>
  );
}

export default SpeakersWidget;

